export default __webpack_public_path__ + "static/media/CloseCircleFill.6f8d4533.svg";